import React, {useState} from "react";
import {Select} from "grommet";
import { Country }  from 'country-state-city';

const getCountryOptions = () => {
    //Regions and countries excluded
    const excludedCountries = ['Antarctica','Iran','North Korea','Syria','Venezuela', 'Cuba','Turkey'];
    let countryOptions = (Country.getAllCountries().filter(country => !excludedCountries.includes(country.name))).map(country => ({
        value: country.isoCode,
        label: country.name,
        testStr: country.name.toLowerCase()
    }));
    // put USA first in the list
    const USindex = countryOptions.findIndex(country => country.value === "US");
    const USobj = countryOptions.splice(USindex, 1);
    return [...USobj, ...countryOptions];
}

const CountryInput = ({
    value, onChange, ...rest
}) => {
    const fullCountryOptions = getCountryOptions();
    const [options, setOptions] = useState(fullCountryOptions);

    return (
        <Select
            size="medium"
            placeholder="Select country"
            value={value}
            options={options}
            onChange={(event) => onChange && onChange(event)}
            labelKey="label"
            valueKey={{ key: 'value', reduce: true }}
            onClose={() => setOptions(getCountryOptions())}
            onSearch={text => { 
                if (!text) { // if user reset search string, render full set of options again
                    setOptions(fullCountryOptions);
                } 
                const escapedText = text.toLowerCase().replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&');
                const exp = new RegExp(escapedText, 'i');
                setOptions(fullCountryOptions.filter(option => exp.test(option.testStr)));
            }}
            {...rest}
        />
    );
};

export default CountryInput;
